export default "__VITE_ASSET__XD7rsZ17__"